import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subtree } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { PATH_BREADCRUMB } from 'src/assets/data/list_path_breadcrumb';

@Component({
  selector: 'app-breadcrumb-first',
  templateUrl: './breadcrumb-first.component.html',
  styleUrls: ['./breadcrumb-first.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class BreadcrumbFirstComponent implements OnInit {

  @Input() title: string = "";
  @Input() type_page: string = "";
  @Input() isSecondLevelUp: boolean = false;
  public newBreadcrumb: any[] = [];
  public headerMainMenu: Subtree[] = this.navigationService.headerMainMenu;
  private list_path = PATH_BREADCRUMB;

  constructor(public helpersService: HelpersService, public navigationService: NavigationService, private router: Router) { }

  ngOnInit(): void {
    this.setBreadcrumb();
  }

  private setBreadcrumb(): void {
    for (const headerMenu of this.headerMainMenu) {      
      if (headerMenu.label.replaceAll(' ', '').toLocaleLowerCase() === "newsroom") {
        switch (this.type_page) {
          case 'archivio_evento':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: headerMenu.subtree[1].label,
                link: headerMenu.subtree[1].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          case 'evento':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: headerMenu.subtree[1].label,
                link: headerMenu.subtree[1].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          case 'archivio_notizia':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: headerMenu.subtree[0].label,
                link: headerMenu.subtree[0].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          case 'notizia':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: headerMenu.subtree[0].label,
                link: headerMenu.subtree[0].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          case 'avviso':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: headerMenu.subtree[2].label,
                link: headerMenu.subtree[2].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          default:           
            break;
        }
      }
      if (headerMenu.label.replaceAll(' ', '').toLocaleLowerCase() === "docentiericerca" || headerMenu.label.replaceAll(' ', '').toLocaleLowerCase() === "professorsandresearch") {
        switch (this.type_page) {
          case 'docente':
            this.newBreadcrumb = [
              {
                label: headerMenu.subtree[0].label,
                link: headerMenu.subtree[0].link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          default:
            break;
        }
      }
      if (headerMenu.label.replaceAll(' ', '').toLocaleLowerCase() === "corsi" || 
      headerMenu.label.replaceAll(' ', '').toLocaleLowerCase() === "courses" || 
      headerMenu.label.trim().toLocaleLowerCase() === "teaching") {
        switch (this.type_page) {
          case 'corso_di_studi':
            this.newBreadcrumb = [
              {
                label: headerMenu.label,
                link: headerMenu.link
              },
              {
                label: this.title,
                link: this.router.url
              }
            ];
            break;
          default:
            break;
        }
      }
    }
    if (this.newBreadcrumb && !this.newBreadcrumb.length && this.helpersService.isBrowser) {
      const path = window.location.pathname;
      switch (this.type_page) {
        case 'convenzione':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'convenzioni', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        case 'alloggio_residenza':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'alloggi', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        case 'bando':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'bandi', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        case 'faq':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'faq', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        case 'persona':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'persone', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        case 'procedura_servizio':
          this.newBreadcrumb = this.generateBreadcrumb(path, 'procedure', this.list_path[this.type_page].it, this.list_path[this.type_page].en);
          break;
        default:
          this.newBreadcrumb = [
            {
              label: this.title,
              link: this.router.url
            }
          ];
          break;
      }
    }    
  }

  private generateBreadcrumb(url: string, entity: string, pathITA: string, pathENG: string) {
  // Divide l'URL in segmenti
  const segments = url.split('/');
  // Inizializza il breadcrumb come un array vuoto
  const breadcrumb = [];
  // Variabile per tenere traccia se l'`entity` è stata trovata nei segmenti
  let entityFound = false;

  // Configurazione dei link fissi per le entità in base alla lingua
  const fixedLinks: Record<string, Record<string, string>> = {
    it: {
      [entity]: pathITA,
    },
    en: {
      [entity]: pathENG,
    },
  };


  // Trova l'indice del segmento della lingua ('it' o 'en')
  const languageIndex = segments.indexOf('it') !== -1 ? segments.indexOf('it') : segments.indexOf('en');
  const language = segments[languageIndex];

  // Itera sui segmenti dell'URL
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i].trim();

    // Controlla se il segmento corrente è uguale all'`entity`
    if (segment === entity) {
      entityFound = true;
    }

    // Se il segmento è valido e diverso da 'it' e 'en', aggiungilo al breadcrumb
    if (segment && segment !== 'it' && segment !== 'en') {
      breadcrumb.push({
        label: segment.replace(/-/g, ' '),
        link: segments.slice(0, i + 1).join('/')
      });
    }
  }

  // Se l'`entity` non è stata trovata, aggiungila in prima posizione nel breadcrumb
  if (!entityFound) {
    breadcrumb.splice(0, 0, {
      label: entity.replace(/-/g, ' '),
      link: fixedLinks[language][entity] || segments.slice(0, languageIndex + 1).join('/') + '/' + entity
    });
  } else {
    // Altrimenti, trova l'indice dell'`entity` nel breadcrumb e spostala in prima posizione
    const entityIndex = breadcrumb.findIndex(item => item.label === entity.replace(/-/g, ' '));
    const entityItem = breadcrumb.splice(entityIndex, 1)[0];
    // Aggiorna il link dell'entità con il link fisso corrispondente alla lingua
    entityItem.link = fixedLinks[language][entity] || entityItem.link;
    breadcrumb.splice(0, 0, entityItem);
  }

  // Inizializza l'array dei risultati
  const result = [];
  // Itera sul breadcrumb per creare i risultati con le label capitalizzate
  for (let i = 0; i < breadcrumb.length; i++) {
    const decodedLabel = decodeURIComponent(breadcrumb[i].label);
    const labelWords = decodedLabel.split(' ');
    const capitalizedLabelWords = labelWords.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    
      // Aggiunge l'elemento del breadcrumb con la label capitalizzata e il link corretto all'array dei risultati
      result.push({
        label: capitalizedLabelWords.join(' '),
        link: breadcrumb[i].link
      });
    }
  
    // Restituisce l'array dei risultati
    return result;
  }  
  
  
}
